import type { FloorAreaTakeoffs } from "building-types/rooms/takeoffTypes";
import { polygonUnion } from "geom/polygon";
import { polyLine2Close } from "geom/polyLine2";
import { polygonArea } from "geom/polyLine2Polygon";
import type { PolyLine2 } from "geom/polyLine2Types";

/**
 * @param paths An array of paths that may or may not be self-intersecting
 * @returns The area in square inches of the union of the paths
 */
export function multiPolyLineArea(paths: PolyLine2[]): number {
  if (paths.length === 0) {
    return 0;
  }

  const unions = polygonUnion(paths.map((x) => [polyLine2Close(x)]));
  return unions.reduce((area, x) => area + polygonArea(x), 0);
}

export function floorAreaTakeoffsGetConditionedArea(floorAreaTakeoffs: FloorAreaTakeoffs): number {
  return floorAreaTakeoffs?.CONDITIONED_FLOOR_AREA?.totalFloorArea ?? 0;
}
